import { DocumentOrientation, DocumentSize, TransactionType } from "@/enums/enums";
import { waitForElement } from "./elementHelper";
import { DocumentGeneratePdfModel } from "@/model/document/documentModel";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const AllowToDownloadClientSide = (transactionType: TransactionType = TransactionType.None): boolean => {
  let allow: boolean = false;

  switch (transactionType) {
    case TransactionType.Quotation:
    case TransactionType.Invoice:
    case TransactionType.Receipt:
    case TransactionType.TaxInvoice:
    case TransactionType.CreditNote:
    case TransactionType.BillingNote:
    case TransactionType.DebitNote:
    case TransactionType.DailyJournal:
    case TransactionType.WithholdingTax:
    case TransactionType.Pnd1:
    case TransactionType.Pnd2:
    case TransactionType.Pnd3:
    case TransactionType.Pnd53:
      allow = true;
      break;
    default:
      allow = false;
  }

  return allow;
};

const MappingContentPdf = async (
  transactionType: TransactionType = TransactionType.None
): Promise<{
  contents: any[];
  paperSize: DocumentSize;
  paperOrientation: DocumentOrientation;
  paperClassName: string;
}> => {
  let paperClassName: string = "paperTransaction";
  let paperSize: DocumentSize = DocumentSize.A4;
  let paperOrientation: DocumentOrientation = DocumentOrientation.Portrait;

  if (transactionType === TransactionType.DailyJournal) {
    paperClassName = "paperDailyJournal";
  } else if (transactionType === TransactionType.WithholdingTax) {
    paperClassName = "paperWithholdingTax";
    const isA5Landscape: boolean = document.getElementsByClassName("paperA5Landscape").length > 0;
    if (isA5Landscape) {
      paperSize = DocumentSize.A5;
      paperOrientation = DocumentOrientation.Landscape;
    }
  } else if (transactionType === TransactionType.Pnd1) {
    const isA5Landscape: boolean = document.getElementsByClassName("paperPnd1Item").length > 0;
    if (isA5Landscape) {
      paperSize = DocumentSize.A5;
      paperOrientation = DocumentOrientation.Landscape;
      paperClassName = "paperPnd1Item";
    } else {
      paperClassName = "paperPnd1";
    }
  } else if (transactionType === TransactionType.Pnd2) {
    const isA5Landscape: boolean = document.getElementsByClassName("paperPnd2Item").length > 0;
    if (isA5Landscape) {
      paperSize = DocumentSize.A5;
      paperOrientation = DocumentOrientation.Landscape;
      paperClassName = "paperPnd2Item";
    } else {
      paperClassName = "paperPnd2";
    }
  } else if (transactionType === TransactionType.Pnd3) {
    const isA5Landscape: boolean = document.getElementsByClassName("paperPnd3Item").length > 0;
    if (isA5Landscape) {
      paperSize = DocumentSize.A5;
      paperOrientation = DocumentOrientation.Landscape;
      paperClassName = "paperPnd3Item";
    } else {
      paperClassName = "paperPnd3";
    }
  } else if (transactionType === TransactionType.Pnd53) {
    const isA5Landscape: boolean = document.getElementsByClassName("paperPnd53Item").length > 0;
    if (isA5Landscape) {
      paperSize = DocumentSize.A5;
      paperOrientation = DocumentOrientation.Landscape;
      paperClassName = "paperPnd53Item";
    } else {
      paperClassName = "paperPnd53";
    }
  } // end if-else type of report pdf

  const numberOfPaper: number = document.getElementsByClassName(`${paperClassName}`).length;

  const promiseElements = [];
  for (let i = 0; i < numberOfPaper; i++) {
    promiseElements.push(waitForElement(`${paperClassName}`, i));
  }

  const contents = await Promise.all(promiseElements);
  return { contents, paperSize, paperOrientation, paperClassName };
};

const ConvertHtmlToCanvas = async (contents: any[], paperClassName: string) =>  {
  const canvases = await Promise.all(
    contents.map(async (content, i) => {
      const canvas = await html2canvas(content, {
        scale: 3,
        useCORS: true,
        logging: false,
        onclone: (document) => {
          const paperElementStyle = (
            document.querySelectorAll(`.${paperClassName}`)[
              i
            ] as HTMLElement
          ).style;
          if (paperElementStyle) {
            paperElementStyle.border = "0";
            paperElementStyle.boxShadow = "0";
          }
        },
      });
      return canvas;
    })
  );

  return canvases;
}

const AddCanvasesToPDF = (canvases: any[], doc: jsPDF, width: number, height: number, input: DocumentGeneratePdfModel) => {
  let count = 0;
  canvases.forEach((canvas) => {
    const base64image = canvas.toDataURL("image/jpeg");
    doc.addImage(
      base64image,
      "JPG",
      0,
      0,
      width,
      height,
      `${input.transactionNumber} (${count})`,
      "SLOW"
    );
    count++;
    if (count < canvases.length) {
      doc.addPage();
    }
  });
}

 const ConvertDocToBase64String = (doc: jsPDF) => {
  const blobPDF = new Blob([doc.output("blob")], {
    type: "application/pdf",
  });

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blobPDF);
    reader.onloadend = () => {
      const base64String = reader.result?.toString();
      const base64StringWithoutTag = base64String?.substr(base64String.indexOf(",") + 1);
      resolve(base64StringWithoutTag);
    };
    reader.onerror = reject;
  });
}

const GetParamsForPDFLogService = (urlParams: URLSearchParams, base64StringWithoutTag: any) => {
  return {
    url: window.location.href,
    merchantId: atob(urlParams.get("emi") || ""),
    transactionId: atob(urlParams.get("eti") || ""),
    transactionTypeId: atob(urlParams.get("etti") || ""),
    financeTypeId: atob(urlParams.get("efti") || ""),
    pdfBase64: base64StringWithoutTag || "",
  }
}

export { AllowToDownloadClientSide, MappingContentPdf, ConvertHtmlToCanvas, AddCanvasesToPDF ,ConvertDocToBase64String, GetParamsForPDFLogService};
